import { render, staticRenderFns } from "./DBasicInfo.vue?vue&type=template&id=30dc21a6&scoped=true&"
import script from "./DBasicInfo.vue?vue&type=script&lang=js&"
export * from "./DBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./DBasicInfo.vue?vue&type=style&index=0&id=30dc21a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dc21a6",
  null
  
)

export default component.exports